import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

export const sameOwnerFolders = (files: UploadedFile[], file: UploadedFile) =>
  files.filter(f => f.isFolder && f.clientId === file.clientId);
